import Model from './Model';

export default class Voucher extends Model {
    readonly id: number;
    readonly code: string;
    readonly resellerId: number;
    readonly amount_value: number;
    readonly amount_currency: string;
    readonly created_at: string;
    readonly consumed_at: string;
    readonly print_count: number;
}

export enum VoucherStatuses {
    ALL = 'all',
    USED = 'used',
    NOT_USED = 'not_used',
}

export type VoucherStatus = `${VoucherStatuses}`;
